import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "scenario-field-header with-elements bg-secondary text-white" }
const _hoisted_2 = {
  key: 0,
  class: "float-end"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "mx-auto" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "d-flex justify-content-end" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "card-body px-4" }
const _hoisted_9 = {
  key: 0,
  class: "d-flex align-items-center mt-4"
}
const _hoisted_10 = { class: "flex-grow-1 px-2" }
const _hoisted_11 = { class: "text-body" }
const _hoisted_12 = {
  key: 1,
  class: "list-group-item text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_modal = _resolveComponent("modal")!
  const _component_user_image = _resolveComponent("user-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[8] || (_cache[8] = _createTextVNode(" Trainer ")),
      (!_ctx.trainer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_modal, {
              modelValue: _ctx.modal,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modal) = $event))
            }, _createSlots({
              header: _withCtx(() => [
                _cache[6] || (_cache[6] = _createTextVNode("Select a Trainer"))
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Loading, {
                  active: _ctx.loading,
                  "is-full-page": false
                }, null, 8, ["active"]),
                _createElementVNode("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event))
                  }, [
                    _cache[7] || (_cache[7] = _createElementVNode("option", {
                      selected: "",
                      disabled: "",
                      hidden: ""
                    }, "-- Select A Trainer --", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trainers, (item, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: item.id
                      }, _toDisplayString(item.name), 9, _hoisted_5))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.selected]
                  ])
                ])
              ]),
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    class: "btn btn-default mx-2",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modal = !_ctx.modal))
                  }, "Cancel"),
                  _createElementVNode("button", {
                    disabled: _ctx.loading,
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
                    class: "btn btn-primary"
                  }, "Save", 8, _hoisted_7)
                ])
              ]),
              _: 2
            }, [
              (_ctx.canEdit)
                ? {
                    name: "trigger",
                    fn: _withCtx((triggerProps) => [
                      (!_ctx.scenario.data.trainer || !_ctx.trainer)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: triggerProps.click,
                            type: "button",
                            class: "btn slim-button btn-primary"
                          }, _cache[5] || (_cache[5] = [
                            _createElementVNode("span", { class: "fa fa-plus" }, null, -1),
                            _createTextVNode(" Add ")
                          ]), 8, _hoisted_3))
                        : _createCommentVNode("", true)
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["modelValue"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.trainer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_user_image, {
              source: _ctx.trainer.image
            }, null, 8, ["source"]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.trainer.name), 1)
            ]),
            (_ctx.canEdit)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "javascript:void(0)",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args))),
                  class: "d-block text-light text-large fw-light"
                }, "×"))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_12, " No Trainer Selected"))
    ])
  ], 64))
}